import numeral from 'numeral';
import 'numeral/locales/es-es';
import { langAndRegion } from 'helpers/i18n';
if (['es-es'].includes(langAndRegion))
    numeral.locale(langAndRegion);
else if (['es'].includes(langAndRegion))
    numeral.locale(langAndRegion + '-es');
// console.log('Format - langAndRegion:', langAndRegion)
export const toNumber = (n) => numeral(n).format('0,0.[00]');
export const toRound = (n) => numeral(n).format('0,0.00');
// export const toMoney = (n: number | string) => numeral(n).format('0,0.00 $')
export const toMoney = (n, money) => {
    if (money) {
        return `${numeral(n).format('0,0.00')} ${money}`;
    }
    return numeral(n).format('0,0.00 $');
};
export const toMoneyDecimal = (n, money) => (numeral(n).format('0,0.00') + ' ' + money.toUpperCase());
export const round = (n, decimals = 2) => Number(Math.round(Number(n + 'e' + decimals)) + 'e-' + decimals);
export const fromMoney = (value) => {
    if (typeof value === 'string') {
        const splited = value.split(' ');
        console.log('splited: ', splited);
        return Number(splited[0]);
    }
    return value;
};
export const toPercentage = (n) => numeral(n).format('0.[00] %');
export const toPorciento = (n) => `${n}%`;
const parseDate = (d) => typeof d === 'string' ? (Date.parse(d) ? new Date(d) : new Date()) : d;
export const toDate = (d) => parseDate(d).toLocaleDateString();
export const toTime = (d) => parseDate(d).toLocaleTimeString();
export const toDateTime = (d) => parseDate(d).toLocaleString();
export const toStringNumber = (n) => n > 9 ? String(n) : `0${n}`;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Format.ts
// module id = 14
// module chunks = 0